// externals
import type { FC } from 'react';

// libraries
import { Typography } from '@interstate/components/Typography';
import type { TradeReconSingleTradeProps } from '@makemydeal/dr-dash-store/types/tradeReconCostTypes';

import { TradeReconItemsList } from '../TradeReconItemsList/TradeReconItemsList';
import { TradeReconValuationSection } from '../TradeReconValuationSection/TradeReconValuationSection';
import { TradeContainer, TradeHeader, TotalDivider, TotalWrapper } from '../tradeReconCost.styles';

export const TradeReconSingleTrade: FC<TradeReconSingleTradeProps> = ({
    tradeKey,
    tradeIndex,
    trade,
    data,
    isLastTrade,
    reconItemOptions,
    onValuationChange,
    onReconItemNameChange,
    onReconItemAmountChange,
    onAddReconItem,
    onRemoveReconItem
}) => {
    return (
        <TradeContainer isLastTrade={isLastTrade}>
            {/* Trade Header */}
            <TradeHeader>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                    Trade {tradeIndex + 1}: {trade.tradeIn.year} {trade.tradeIn.make} {trade.tradeIn.model}
                </Typography>
            </TradeHeader>

            {/* Valuation Section */}
            <TradeReconValuationSection
                tradeKey={tradeKey}
                value={data.value}
                acv={data.acv}
                amountOwed={data.amountOwed}
                onValuationChange={onValuationChange}
            />

            {/* Reconditioning Items List */}
            <TradeReconItemsList
                tradeKey={tradeKey}
                reconItems={data.tradeReconditionItems}
                reconItemOptions={reconItemOptions}
                onNameChange={onReconItemNameChange}
                onAmountChange={onReconItemAmountChange}
                onRemove={onRemoveReconItem}
                onAdd={onAddReconItem}
            />

            {/* Total */}
            {!isLastTrade && <TotalDivider />}
            <TotalWrapper>
                <Typography sx={{ fontWeight: 400 }} variant="h6">
                    Total
                </Typography>
                <Typography sx={{ fontWeight: 600 }} data-testid={`${tradeKey}-total`} variant="h6">
                    ${data.tradeReconditionTotal.toFixed(2)}
                </Typography>
            </TotalWrapper>
        </TradeContainer>
    );
};

export default TradeReconSingleTrade;
